import React from 'react';
import { Box } from '@leagueplatform/genesis-core';
import {
  AnyMasonryEngineNode,
  type MasonryEngineNode,
  type MasonryEngineNodeRendererProps,
} from '@leagueplatform/masonry-engine';
import { formatClassNames } from '../../utils/format-masonry-class-name.util';

export type MasonryBoxNode = MasonryEngineNode<
  'box',
  {},
  {},
  {
    items: AnyMasonryEngineNode[];
  }
>;

export type MasonryBoxNodeRendererProps =
  MasonryEngineNodeRendererProps<MasonryBoxNode>;

export const MasonryBoxNodeRenderer = ({
  items,
  className,
  engineClassName,
  locatorId,
  css,
  rootElementRef,
}: MasonryBoxNodeRendererProps) => (
  <Box
    ref={rootElementRef}
    className={formatClassNames(className, engineClassName)}
    css={css}
    data-locator-id={locatorId}
  >
    {items}
  </Box>
);
